/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SpecialOpeningDay } from './SpecialOpeningDay';
import {
    SpecialOpeningDayFromJSON,
    SpecialOpeningDayFromJSONTyped,
    SpecialOpeningDayToJSON,
} from './SpecialOpeningDay';
import type { WeekdayOpeningDay } from './WeekdayOpeningDay';
import {
    WeekdayOpeningDayFromJSON,
    WeekdayOpeningDayFromJSONTyped,
    WeekdayOpeningDayToJSON,
} from './WeekdayOpeningDay';

/**
 * Representation of an Opening schedule
 * @export
 * @interface OpeningSchedule
 */
export interface OpeningSchedule {
    /**
     * Name of the opening schedule
     * @type {string}
     * @memberof OpeningSchedule
     */
    name?: string;
    /**
     * Code of the opening schedule
     * @type {string}
     * @memberof OpeningSchedule
     */
    code?: string;
    /**
     * List of weekday opening days
     * @type {Array<WeekdayOpeningDay>}
     * @memberof OpeningSchedule
     */
    weekDayOpeningList?: Array<WeekdayOpeningDay>;
    /**
     * List of special opening days
     * @type {Array<SpecialOpeningDay>}
     * @memberof OpeningSchedule
     */
    specialDayOpeningList?: Array<SpecialOpeningDay>;
}

/**
 * Check if a given object implements the OpeningSchedule interface.
 */
export function instanceOfOpeningSchedule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OpeningScheduleFromJSON(json: any): OpeningSchedule {
    return OpeningScheduleFromJSONTyped(json, false);
}

export function OpeningScheduleFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpeningSchedule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'weekDayOpeningList': !exists(json, 'weekDayOpeningList') ? undefined : ((json['weekDayOpeningList'] as Array<any>).map(WeekdayOpeningDayFromJSON)),
        'specialDayOpeningList': !exists(json, 'specialDayOpeningList') ? undefined : ((json['specialDayOpeningList'] as Array<any>).map(SpecialOpeningDayFromJSON)),
    };
}

export function OpeningScheduleToJSON(value?: OpeningSchedule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'code': value.code,
        'weekDayOpeningList': value.weekDayOpeningList === undefined ? undefined : ((value.weekDayOpeningList as Array<any>).map(WeekdayOpeningDayToJSON)),
        'specialDayOpeningList': value.specialDayOpeningList === undefined ? undefined : ((value.specialDayOpeningList as Array<any>).map(SpecialOpeningDayToJSON)),
    };
}

